import React, { useEffect, useState } from "react";
import style from "./beetle-lague.module.css";

import CaterPillarIamge from "../../../../images/beetle-colored.png";
import logger from "../../../../utils/logger";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import TotalInformations from "./total-informations/total-informations";
import ParkOutlinedIcon from "@mui/icons-material/ParkOutlined";

function BeetlePlague({ plague, infestation, data }) {
  const [samples, setSamples] = useState([]);
  const [unsheet, setUnsheet] = useState();
  const [levelInfestation, setLevelInfestation] = useState("");

  // Validar se plague é um objeto válido (após hooks)
  const isValidPlague = plague && typeof plague === "object" && plague.name && plague.scientific;

  const handleClickRemoveBeetle = (index) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualDesfolha -= 1;
    if (updatedAmostras[index].percentualDesfolha < 0) {
      updatedAmostras[index].percentualDesfolha = 0;
    }
    setSamples(updatedAmostras);
  };
 
  const handleClickAddCaterpillar = (index) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualDesfolha += 1;
    if (updatedAmostras[index].percentualDesfolha < 0) {
      updatedAmostras[index].percentualDesfolha = 0;
    }
    setSamples(updatedAmostras);
  };

  

  useEffect(() => {
    const amostra = Array.from({ length: 5 }).map((_, index) => ({
      planta: index + 1,
      percentualDesfolha: 0,
    }));
    setSamples(amostra);
  }, []);

  const handleChangeUnsheet = (index, value) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualDesfolha = value;
    setSamples(updatedAmostras);
  };

  const handleChangeInfestation = (information) => {
    let info = information;

    infestation(info);
  };

  useEffect(() => {
    if (data && isValidPlague) {
      data(samples);
    }
  }, [samples, data, isValidPlague]);

  // Retornar null se plague não for válido (após todos os hooks)
  if (!isValidPlague) {
    logger.warn("Objeto de praga inválido:", plague);
    return null;
  }

  return (
    <div className={style["beetle-plague"]}>
      <div className={style["card"]}>
        <div className={style["sample-plague"]}>
          <img src={CaterPillarIamge} />
          <div className={style["name-sample-plague"]}>
            <div>{plague.name}</div>
            <div>{plague.scientific}</div>
          </div>
        </div>

        <div className={style["samples"]}>
          {samples.map((sample, index) => (
            <div className={style["collected-sample-title"]} key={index}>
              <div className={style["collected-sample-plant"]}>
                <div className={style["collected-sample-plant-number"]}>
                  {index + 1}° <ParkOutlinedIcon style={{ width: "0.8rem" }} />
                </div>
              </div>

              <div className={style["information-unsheet"]}>
                <div className={style["name"]}> % de Desfolha </div>
                <div className={style["contianer-input"]}>
                  <RemoveIcon
                    onClick={(e) => handleClickRemoveBeetle(index)}
                    className={style["icon"]}
                  />
                  <input
                    value={sample.percentualDesfolha}
                    className={style["input"]}
                    type="number"
                    onChange={(e) => handleChangeUnsheet(index, e.target.value)}
                  ></input>
                  <AddIcon
                    onClick={(e) => handleClickAddCaterpillar(index)}
                    className={style["icon"]}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <TotalInformations
        samples={samples}
        infestation={handleChangeInfestation}
      />
    </div>
  );
}

export default BeetlePlague;
